import ReactDOM from 'react-dom';
import { PropsWithChildren } from 'react';

export function BodyPortal({ children }: PropsWithChildren<{}>) {
  return ReactDOM.createPortal(children, document.body);
}
